import React from "react";
import Button, { ButtonType } from "../../../../components/Button/Button";
import { StyledFormField } from "../../../../components/styled/styled-components";
import { Address } from "../../../../interfaces/interfaces";
import AUAddressForm, { Form } from "../AUAddressForm";
import RenderSelectedAddress from "./RenderSelectedAddress";

interface EditAddressFormProps {
  selectedAddress: Address;
  branch: string;
  form: Form;
  isFormValid: boolean;
  onFormChange: (form: Form) => void;
  onAddressChange: (value: React.SetStateAction<Address | null>) => void;
  onSave: () => void;
  onCancel: () => void;
}

const EditAddressForm: React.FC<EditAddressFormProps> = ({
  selectedAddress,
  branch,
  form,
  isFormValid,
  onFormChange,
  onAddressChange,
  onSave,
  onCancel,
}) => {
  return (
    <div className="address-edit-form">
      {branch === "au" ? (
        <AUAddressForm form={form} onFormChange={onFormChange} />
      ) : (
        <RenderSelectedAddress
          selectedAddress={selectedAddress}
          branch={branch}
          setSelectedAddress={onAddressChange}
        />
      )}
      <StyledFormField>
        <label />
        <div className="address-form-actions" style={{ marginBottom: "1em", marginTop: "1rem" }}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Button type={ButtonType.primary} onClick={onSave} disabled={!isFormValid}>
              Save Changes
            </Button>
            <Button type={ButtonType.secondary} onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </StyledFormField>
    </div>
  );
};

export default EditAddressForm;
